// This technique is recommended by:
// https://webaim.org/techniques/css/invisiblecontent

export default function ScreenReaderOnly({ children }) {
  return (
    <div
      style={{
        position: 'absolute',
        left: '-10000px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
      }}
    >
      {children}
    </div>
  );
}
